document.addEventListener('DOMContentLoaded', () => {
  if (!location.pathname.includes('/cart')) return;
  if (window.matchMedia('(min-width: 750px)').matches) return;

  const tidy = () => {
    // Excl. BTW uit price nodes halen
    document.querySelectorAll('.price.price--end').forEach(el => {
      el.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          node.nodeValue = node.nodeValue.replace(/\s*Excl\.?\s*BTW\s*/gi, ' ').trim();
        }
      });
    });

    // Huurperiode-regel verwijderen
    document.querySelectorAll('.cart-item__details p, .cart-item__details div, .cart-item__details li, .cart-item__details span, .cart-item__details dd')
      .forEach(el => {
        const t = (el.textContent || '').trim();
        if (/^huurperiode\s*:/i.test(t)) el.remove();
      });

    // Start/Einde op 2 regels samenvoegen
    document.querySelectorAll('.cart-item').forEach(item => {
      const details = item.querySelector('.cart-item__details');
      if (!details) return;

      let start = null, end = null;

      details.querySelectorAll('p, div, li, span, dd').forEach(el => {
        const t = (el.textContent || '').trim();

        if (/^start huur\s*:/i.test(t)) {
          start = t.replace(/^start huur\s*:/i, '').trim();
          el.remove();
        } else if (/^einde huur\s*:/i.test(t)) {
          end = t.replace(/^einde huur\s*:/i, '').trim();
          el.remove();
        }
      });

      if (!start && !end) return;

      const existing = details.querySelector('.huurperiode-combined');
      if (existing) existing.remove();

      const wrap = document.createElement('div');
      wrap.className = 'huurperiode-combined';

      if (start) {
        const p1 = document.createElement('p');
        p1.textContent = `Start: ${start}`;
        wrap.appendChild(p1);
      }
      if (end) {
        const p2 = document.createElement('p');
        p2.textContent = `Einde: ${end}`;
        wrap.appendChild(p2);
      }

      details.appendChild(wrap);
    });
  };

  tidy();

  const target = document.querySelector('cart-items') || document.querySelector('#cart') || document.body;
  new MutationObserver(() => window.requestAnimationFrame(tidy))
    .observe(target, { childList: true, subtree: true });
});
